const mobile = window.matchMedia('(max-width: 749px)');
let frame;
function updateProofWidth() {
  const width = document.documentElement.clientWidth;
  document.querySelectorAll('#MainContent .pf-customer-proof').forEach(banner => {
    if (!mobile.matches) {
      banner.style.removeProperty('--pf-proof-screen-width');
      banner.style.removeProperty('--pf-proof-offset');
      return;
    }
    banner.style.setProperty('--pf-proof-screen-width', `${width}px`);
    const margin = parseFloat(getComputedStyle(banner).marginLeft) || 0;
    const origin = banner.getBoundingClientRect().left - margin;
    banner.style.setProperty('--pf-proof-offset', `${-origin}px`);
  });
}
function schedule() {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(updateProofWidth);
}
updateProofWidth();
window.addEventListener('resize', schedule, { passive: true });
mobile.addEventListener('change', schedule);
document.addEventListener('shopify:section:load', schedule);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
new ResizeObserver(schedule).observe(document.documentElement);
